import { render, staticRenderFns } from "./LoaderFullscreen.vue?vue&type=template&id=1b23cdab&scoped=true&"
import script from "./LoaderFullscreen.vue?vue&type=script&lang=js&"
export * from "./LoaderFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./LoaderFullscreen.vue?vue&type=style&index=0&id=1b23cdab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23cdab",
  null
  
)

export default component.exports